<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">
          PDI Queue
        </h1>
      </template>
    </page-header>

    <road-test-monitor v-if="hasPermission('pdi.monitor')"></road-test-monitor>

    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="loading-overlay" v-if="loading"></div>
          <div class="card-header">
            <div class="row w-100">
              <div class="col">
                <selectlist
                  name="abi_group_id"
                  label="ABI Group"
                  :value="filters.abi_group_id"
                  @input="setAbiGroup"
                  :options="vehicleGroups"
                  :stacked="true"
                  key-name="id"
                  label-name="name"
                ></selectlist>
              </div>
              <div class="col">
                <div>
                  <label class="control-label">Registration:</label>
                  <input
                    type="text"
                    name="registration"
                    class="form-control"
                    placeholder="Search by registration"
                    :value="filters.registration"
                    @input="setRegistration($event.target.value)"
                  />
                </div>
              </div>
              <div class="col" v-if="hasPermission('pdi.completed')">
                <selectlist
                  name="status"
                  label="Status"
                  :value="filters.status"
                  @input="setStatus"
                  :options="statuses"
                  :stacked="true"
                  key-name="key"
                  label-name="value"
                ></selectlist>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>PDI Number</th>
                  <th>QC Number</th>
                  <th>Vehicle</th>
                  <th>ABI Group</th>
                  <th>Collected</th>
                  <th>Completed?</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody v-if="!!pdis && pdis.length">
                <tr v-bind:key="index" v-for="(pdi, index) in pdis">
                  <td>
                    {{ pdi.pdi_number }}
                  </td>
                  <td>
                    {{ !pdi.completed_at ? pdi.qc_number : '' }}
                  </td>
                  <td>
                    {{ pdi.vehicle?.registration }}
                  </td>
                  <td>
                    {{ pdi.abiGroup?.name }}
                  </td>
                  <td>
                    {{ pdi.created_at | date }}
                  </td>
                  <td>
                    <span
                      class="badge"
                      :class="{
                        'badge-success': pdi.completed_at,
                        'badge-danger': !pdi.completed_at
                      }"
                    >
                      {{ pdi.completed_at ? 'Yes' : 'No' }}
                    </span>
                  </td>
                  <td class="text-right">
                    <router-link
                      class="btn btn-primary"
                      :to="`/pdi-queue/${pdi.identifier}`"
                    >
                      View
                    </router-link>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="!pdis.length">
                <tr>
                  <td colspan="7" class="text-center">
                    No results found
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="card-footer text-right" v-show="showPagination">
            <pagination
              :data="paginator_data"
              v-on:updateResults="getData"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from './../Shared/PageHeader.vue';
import RoadTestMonitor from './RoadTest/RoadTestMonitor.vue';

export default {
  components: {
    PageHeader,
    RoadTestMonitor
  },

  data() {
    return {
      loading: false,
      pdis: [],
      paginator_data: {},
      filters: {
        abi_group_id: null,
        registration: '',
        status: 'incomplete'
      },
      statuses: [
        {
          key: null,
          value: 'All'
        },
        {
          key: 'completed',
          value: 'Completed'
        },
        {
          key: 'incomplete',
          value: 'Incomplete'
        },
        {
          key: 'qc_rectification',
          value: 'QC Rectification'
        }
      ],
      searchTimeout: undefined,
      archiveIndicator: undefined
    };
  },

  computed: {
    showPagination() {
      return (
        this.paginator_data.next_page_url || this.paginator_data.prev_page_url
      );
    },

    vehicleGroups() {
      return this.$store.getters['VehicleGroups/all'];
    }
  },

  mounted() {
    this.$store.commit('VehicleGroups/retrieve');

    this.getPdis();
  },

  methods: {
    getPdis() {
      this.getData(`/pdi?per_page=${this.perPage}`);
    },

    getData(url) {
      Object.keys(this.filters).forEach(key => {
        let value = this.filters[key];

        if (key === 'date' && value) {
          value = window.DateManager.format(value, 'YYYY-MM-DD');
        }

        url = `${url}&filter[${key}]=${value || ''}`;
      });

      this.loading = true;

      window.Ajax.get(`${url}&sort=created_at&parts=vehicle,abiGroup`)
        .then(response => {
          this.pdis = response.data.data;
          this.paginator_data = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
        });
    },

    setAbiGroup(abiGroup) {
      this.filters.abi_group_id = abiGroup;

      this.getPdis();
    },

    setStatus(status) {
      this.filters.status = status;

      this.getPdis();
    },

    setRegistration(registration) {
      this.filters.registration = registration;

      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(() => this.getPdis(), 400);
    }
  }
};
</script>
